(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  // 修复 HeaderMenu 滚动问题
  function fixHeaderMenuScroll() {
    const headerMenus = document.querySelectorAll('header-menu');
    
    headerMenus.forEach(menu => {
      const details = menu.querySelector('details');
      const submenu = menu.querySelector('.header__submenu');
      
      if (!details || !submenu) return;
      
      // 监听菜单开关状态
      details.addEventListener('toggle', function() {
        if (this.open) {
          // 菜单打开时，添加滚动事件处理
          addScrollPrevention(submenu);
        } else {
          // 菜单关闭时，移除滚动事件处理
          removeScrollPrevention(submenu);
        }
      });
    });
  }
  
  function addScrollPrevention(menuContent) {
    if (!menuContent) return;
    
    const scrollHandler = function(event) {
      // 阻止滚动事件冒泡到页面
      event.stopPropagation();
      
      // 允许在菜单内容内部滚动
      const { scrollTop, scrollHeight, clientHeight } = menuContent;
      const isScrollingUp = event.deltaY < 0;
      const isScrollingDown = event.deltaY > 0;
      
      // 如果滚动到顶部或底部，阻止继续滚动到页面
      if ((scrollTop === 0 && isScrollingUp) || 
          (scrollTop + clientHeight >= scrollHeight && isScrollingDown)) {
        event.preventDefault();
      }
    };
    
    const touchHandler = function(event) {
      event.stopPropagation();
    };
    
    // 添加事件监听器
    menuContent.addEventListener('wheel', scrollHandler, { passive: false });
    menuContent.addEventListener('touchmove', touchHandler, { passive: false });
    
    // 存储处理器引用以便后续移除
    menuContent._scrollHandler = scrollHandler;
    menuContent._touchHandler = touchHandler;
  }
  
  function removeScrollPrevention(menuContent) {
    if (!menuContent || !menuContent._scrollHandler) return;
    
    // 移除事件监听器
    menuContent.removeEventListener('wheel', menuContent._scrollHandler);
    menuContent.removeEventListener('touchmove', menuContent._touchHandler);
    
    // 清理引用
    delete menuContent._scrollHandler;
    delete menuContent._touchHandler;
  }
  
  // 页面加载完成后初始化 header menu 滚动修复
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', fixHeaderMenuScroll);
  } else {
    fixHeaderMenuScroll();
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ubt-box-image"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const imageBox = document.getElementById('expandableImage');
    const showMoreBox = document.getElementById('show-more-box');
    if (showMoreBox) {
      showMoreBox.addEventListener('click', function() {        
        imageBox.classList.add('expanded');
        // 隐藏父级 div
        this.style.display = 'none';
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ubt-home-comment"] && !Shopify.designMode) return;
  try {
    
  class UbtHomeInfluencer extends HTMLElement {
    constructor() {
      super();
      this.oImg = this.querySelectorAll(".upin-item-img-wrap")

      this.oMore = this.querySelectorAll(".uhcom-re-item")
      this.oPopVideoWrap1 = this.querySelector(".uhcom-big-video-wrap")
			this.oVideoMask1 = this.querySelector(".uhcom-mask1")
			this.oVideoClose1 = this.querySelector(".uhcom-mask-close1")
      this.oReviewMain = this.querySelectorAll(".uhcom-review-main")

      this.init()
    }
    init () {
			let canClick = true
      this.oMore.forEach((item,i) => {
				item.addEventListener("touchmove", () => {
          canClick = false;
          setTimeout(() => {
            canClick = true;
          }, 500);
        });
				// item.addEventListener("mousemove", () => {
        //   canClick = false;
        //   setTimeout(() => {
        //     canClick = true;
        //   }, 500);
        // });
        item.addEventListener("click", () => {
					if (!canClick) {
            return
          }
          let blockId = item.getAttribute("blockId")
					this.oVideoMask1.setAttribute("show", "1")
          this.oReviewMain.forEach(re => {
            let reBlockId = re.getAttribute("blockId")
            let video = re.querySelector(".uhcom-review-left-video")
            if (reBlockId == blockId) {
              re.setAttribute("show", "1")
              if (video) {
                video.currentTime = 0
                video.play()
                if (video.clientWidth < video.clientHeight) {
                  re.querySelector(".uhcom-review-left").classList.add('uhcom-portrait')
                } else {
                  re.querySelector(".uhcom-review-left").classList.remove('uhcom-portrait')
                }
              }
            } else {
              re.setAttribute("show", "")
              if (video) {
                video.pause()
              }
            }
          })
        })
      })
      this.oVideoClose1.addEventListener("click", () => {
				this.oVideoMask1.setAttribute("show", "")
			})
      this.oVideoMask1.addEventListener("click", () => {
				this.oVideoMask1.setAttribute("show", "")
			})
			this.oPopVideoWrap1.addEventListener("click", (e) => {
				e.stopPropagation();
			});
    }

  }
  if (!customElements.get('ubt-home-comment')) {
    customElements.define('ubt-home-comment', UbtHomeInfluencer);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ubt-main-product"] && !Shopify.designMode) return;
  try {
    
    class UProductPage extends HTMLElement {
      constructor() {
          super();
          this.oLeftTops = this.querySelectorAll(".ump-left-top")
          this.oLeftSlicks = this.querySelectorAll(".ump-left-img-slick")
          this.oLeftTabs = this.querySelectorAll(".ump-left-media-tabs")
          this.oLeftDetainPop = document.querySelector(".ubt_leftpop_des")
          document.addEventListener('DOMContentLoaded', () => {
            this.init()
          })
      }
      init () {
          this.oLeftTabs.forEach((item,i) => {
              item.addEventListener("click", () => {
                  this.tabClick(i, item)
              })
          })

          this.oLeftSlicks.forEach((item, i) => {
              let children = item.querySelectorAll(".swiper-slide")
              if (children.length > 1) {
                let swiper = new Swiper(`.ump-slider-${i}`, {
                  loop: true,
                  navigation: {
                    nextEl: `.ump-slider-${i} .ubt-arrow-next`,
                    prevEl: `.ump-slider-${i} .ubt-arrow-prev`,
                  },
                });
                swiper.on('realIndexChange', (e) => {
                  // console.log(e)
                  let realIndex = e.realIndex
                  this.querySelectorAll(".ump-slide-current")[i].innerText = realIndex + 1
                });
              }
          })


          const isScrollFn = () => {
              const wrap = this.querySelector('.ump-left-bottom-left');
              const scroller = this.querySelector('.ump-left-bottom-left-scroller');
              const isScrolled = scroller.scrollWidth > scroller.clientWidth;
              if (isScrolled) {
                  wrap.classList.add("isScroll")
              } else {
                  wrap.classList.remove("isScroll")
              }
          }
          isScrollFn()
          window.addEventListener("resize", isScrollFn)
      }
      tabClick (i, item) {
          this.oLeftTops.forEach(t => { t.classList.remove("ump-act") })
          this.oLeftTabs.forEach(t => { t.classList.remove("ump-act") })
          this.oLeftTops[i].classList.add('ump-act')
          this.oLeftTabs[i].classList.add('ump-act')

          let allVideo = this.querySelectorAll(".ump-left-img-vid")
          if (allVideo) {
              allVideo.forEach(v => {
                  v.pause()
              })
          }
          
          if (this.oLeftTabs[i].getAttribute("block-type") == "product_media_video") {
              let vid = this.oLeftTops[i].querySelectorAll(".ump-left-img-vid")
              vid.forEach(v => {
                  if (window.getComputedStyle(v).display !== "none") {
                      v.play()
                  }
              })
          }
          let oWrap = this.querySelector(".ump-left-bottom-left-scroller")
          if (oWrap && item) {
            const itemRect = item.getBoundingClientRect();
            const wrapRect = oWrap.getBoundingClientRect();
            const scrollLeft = oWrap.scrollLeft;
            const itemCenter = item.offsetLeft + item.offsetWidth / 2;
            const wrapCenter = oWrap.clientWidth / 2;
            oWrap.scrollTo({
              left: itemCenter - wrapCenter,
              behavior: 'smooth'
            });
          }
          

      }
    }
    if (!customElements.get('ubt-product-page')) {
        customElements.define('ubt-product-page', UProductPage);
    }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ubt-product-anchor"] && !Shopify.designMode) return;
  try {
    
class ProductAnchor extends HTMLElement {
  constructor() {
    super();
    this.navBtns = this.querySelectorAll(".upan-top-btn")
    document.addEventListener("DOMContentLoaded", () => {
      this.init()
    })
  }
  init () {
    window.addEventListener("scroll", () => {
      let offset = 0
      if (window.innerWidth <= 1024) {
        offset = 0
      }
      let t = document.documentElement.scrollTop + offset   //根据导航栏高度调整
      let oWrap = this.querySelector('.upan-wrap')
      let oFixed = this.querySelector('.upan-fixed')
      let top = oWrap.offsetTop
      if (top < t) {
        oFixed.setAttribute("show", "1")
      } else {
        oFixed.setAttribute("show", "")
      }

      let oFixedTop = oFixed.offsetTop
      let header = document.querySelector('.section-header')
      if (header) {
        if ((document.documentElement.scrollTop + 50) > oFixedTop) {
          header.classList.add('header-top--100')
        } else {
          header.classList.remove('header-top--100')
        }
      }
      
    })

    let ob = new IntersectionObserver((e) => {
      let entry = e[0]
      if (entry.isIntersecting) {
        this.navBtns.forEach((ite) => {
          ite.setAttribute("show", "")
        })
        this.navBtns.forEach((item,i) => {
          // console.log(item.getAttribute('data-id'),entry.target.getAttribute("id"))
          if (item.getAttribute('data-id') === entry.target.getAttribute("id")) {
            item.setAttribute('show', "1")
            navScrollToCenter(item)
          }
        })
      }
    }, {
      threshold: 0.1
    })

    this.navBtns.forEach((item,i) => {
      let id = item.getAttribute("data-id")
      let dom = document.querySelector("#" + id)
      // console.log('dom', dom)
      if (dom) {
        ob.observe(dom)
      }
      item.addEventListener("click", () => {
        let top = 0
        if (id == 'reviews') {
          dom = document.querySelector("#reviews") //改成插件的css选择器
          // top -= 100
        }
        top += dom.offsetTop
        let offset = -50
        if (window.innerWidth <= 1600) {
          offset = -30
        }
        if (window.innerWidth <= 1024) {
          offset = 0
        }
        window.scrollTo({
          top: top - offset,
          behavior: "smooth"
        })
      })
    })

    // 单独监听reviews，后台的id填reviews
    // let reviewOb = new IntersectionObserver((e) => {
    //   e.forEach(entry => {
    //     if (entry.isIntersecting) {
    //       navBtns.forEach((ite) => {
    //         ite.setAttribute("show", "")
    //       })
    //       let item = document.querySelector('[data-id="reviews"]')
    //       item.setAttribute('show', "1")
    //       navScrollToCenter(item)
    //     }
    //   })
    // }, {
    //   threshold: 0.8
    // })
    // reviews插件的元素渲染比较慢，需要加定时
    // setTimeout(() => {
    //   let oReview = document.querySelector(".AirReviews-CarouselWrapper")
    //   if (oReview) {
    //     reviewOb.observe(oReview)
    //   }
    // }, 2000)

    function navScrollToCenter (item) {
      const lanBg = document.querySelector('.upan-top-ul');
      const rect = item.getBoundingClientRect();
      const bgRect = lanBg.getBoundingClientRect();
      const scrollLeft = lanBg.scrollLeft;
      const itemCenter = rect.left + rect.width / 2;
      const bgCenter = bgRect.left + bgRect.width / 2;
      lanBg.scrollLeft = scrollLeft + (itemCenter - bgCenter);
    }
  }
}
if (!customElements.get('q-product-anchor')) {
  customElements.define('q-product-anchor', ProductAnchor);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ubt-product-certificates"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const showMore = document.getElementById('certificates_show_more');
    if (showMore) {
      showMore.addEventListener('click', function() {        
        // 隐藏 "Show More" 按钮
        this.style.display = 'none';
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ubt-product-grid-media"] && !Shopify.designMode) return;
  try {
    
  class UProductGeidMedia extends HTMLElement {
    constructor() {
      super();
			this.oCards = this.querySelectorAll(".upgm-card-hasVideo")
			this.oPopVideoWrap = this.querySelector(".upgm-video-rela")
			this.oVideoMask = this.querySelector(".upgm-mask")
			this.oVideoClose = this.querySelector(".upgm-mask-close")
      this.init()
    }
    init () {
      let sid = this.getAttribute('sid')
      this.oCards.forEach((item,i) => {
				let blockId = item.getAttribute('block-id')
				item.addEventListener("click", () => {
					let block = window.upgm[blockId]
					let sources = block.video.sources
					let source = sources.find(s => (s.height == 1080) && (s.format == "mp4")) || sources[0]
					let sourceHTML = `<source src="${source.url}" type="video/mp4">`
					let html = `
						<video controls muted autoplay loop class="upgm-big-video">
							${sourceHTML}
						</video>
					`
					this.oPopVideoWrap.innerHTML = html
					this.oVideoMask.setAttribute("show", "1")
          let video = this.querySelector(".upgm-big-video")
          setTimeout(() => {
            video.play()
          }, 100);
				})
			})
			this.oVideoClose.addEventListener("click", () => {
				this.oPopVideoWrap.innerHTML = ""
				this.oVideoMask.setAttribute("show", "")
			})
			this.oVideoMask.addEventListener("click", () => {
				this.oPopVideoWrap.innerHTML = ""
				this.oVideoMask.setAttribute("show", "")
			})
			this.oPopVideoWrap.addEventListener("click", (e) => {
				e.stopPropagation();
			});
    }
  }
  if (!customElements.get('ubt-product-grid-media')) {
    customElements.define('ubt-product-grid-media', UProductGeidMedia);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ubt-product-influencer"] && !Shopify.designMode) return;
  try {
    
  class UbtInfluencer extends HTMLElement {
    constructor() {
      super();
      this.oTabs = this.querySelectorAll(".upin-tab")
      this.oMain = this.querySelectorAll(".upin-main")
      this.oImg = this.querySelectorAll(".upin-item-img-wrap")
      this.oPopVideoWrap = this.querySelector(".upin-video-rela")
			this.oVideoMask = this.querySelector(".upin-mask")
			this.oVideoClose = this.querySelector(".upin-mask-close")

      this.oMore = this.querySelectorAll(".upin-re-item")
      this.oPopVideoWrap1 = this.querySelector(".upin-big-video-wrap1")
			this.oVideoMask1 = this.querySelector(".upin-mask1")
			this.oVideoClose1 = this.querySelector(".upin-mask-close1")
      this.oReviewMain = this.querySelectorAll(".upin-review-main")

      this.init()
      this.initTabFn()
    }
    init () {
      let canClick = true
			this.oImg.forEach((item,i) => {
				let videoId = item.getAttribute('videoid')
				item.addEventListener("click", () => {
          if (!videoId) {
            return
          }
          if (!canClick) {
            return
          }
					let html = `
            <iframe src="https://www.youtube.com/embed/${videoId}?enablejsapi=1&modestbranding=1&autohide=1&showinfo=0&controls=1&mute=0&autoplay=1&loop=1" 
              class="upin-big-video js-youtube" allow="autoplay; loop; controls; encrypted-media" allowfullscreen title=""></iframe>
					`
					this.oPopVideoWrap.innerHTML = html
					this.oVideoMask.setAttribute("show", "1")
				})
        item.addEventListener("touchmove", () => {
          canClick = false;
          setTimeout(() => {
            canClick = true;
          }, 500);
        });
			})
      this.oVideoClose.addEventListener("click", () => {
				this.oPopVideoWrap.innerHTML = ""
				this.oVideoMask.setAttribute("show", "")
			})
			this.oVideoMask.addEventListener("click", () => {
				this.oPopVideoWrap.innerHTML = ""
				this.oVideoMask.setAttribute("show", "")
			})
			this.oPopVideoWrap.addEventListener("click", (e) => {
				e.stopPropagation();
			});

      this.oMore.forEach((item,i) => {
        item.addEventListener("click", () => {
          let blockId = item.getAttribute("blockId")
					this.oVideoMask1.setAttribute("show", "1")
          this.oReviewMain.forEach(re => {
            let reBlockId = re.getAttribute("blockId")
            let video = re.querySelector(".upin-review-left-video")
            if (reBlockId == blockId) {
              re.setAttribute("show", "1")
              if (video) {
                video.currentTime = 0
                video.play()
                if (video.clientWidth < video.clientHeight) {
                  re.querySelector(".upin-review-left").classList.add('upin-portrait')
                } else {
                  re.querySelector(".upin-review-left").classList.remove('upin-portrait')
                }
              }
            } else {
              re.setAttribute("show", "")
              if (video) {
                video.pause()
              }
            }
          })
        })
      })
      this.oVideoClose1.addEventListener("click", () => {
				this.oVideoMask1.setAttribute("show", "")
			})
      this.oVideoMask1.addEventListener("click", () => {
				this.oVideoMask1.setAttribute("show", "")
			})
			this.oPopVideoWrap1.addEventListener("click", (e) => {
				e.stopPropagation();
			});
    }
    initTabFn () {
      this.oTabs.forEach((tab,i) => {
        tab.addEventListener("click", () => {
          this.oTabs.forEach(t => {
            t.classList.remove("upin-act")
          })
          this.oMain.forEach(t => {
            t.classList.remove("upin-act")
          })
          tab.classList.add("upin-act")
          this.oMain[i].classList.add("upin-act")

          const tabWrap = this.querySelector('.upin-tab-wrap');
          const tabRect = tab.getBoundingClientRect();
          const wrapRect = tabWrap.getBoundingClientRect();
          const scrollLeft = tab.offsetLeft - (wrapRect.width / 2) + (tabRect.width / 2);
          tabWrap.scrollTo({ left: scrollLeft, behavior: 'smooth' });
        })
      })
    }
  }
  if (!customElements.get('ubt-influencer')) {
    customElements.define('ubt-influencer', UbtInfluencer);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ubt-product-overview"] && !Shopify.designMode) return;
  try {
    
  class UProductOverview extends HTMLElement {
    constructor() {
      super();
			this.oCards = this.querySelectorAll(".upo-card-hasVideo")
			this.oPopVideoWrap = this.querySelector(".upo-video-rela")
			this.oVideoMask = this.querySelector(".upo-mask")
			this.oVideoClose = this.querySelector(".upo-mask-close")
      this.init()
    }
    init () {
      let sid = this.getAttribute('sid')
      this.oCards.forEach((item,i) => {
				let blockId = item.getAttribute('block-id')
				item.addEventListener("click", () => {
					let block = window.upgm[blockId]
					let sources = block.video.sources
					let source = sources.find(s => (s.height == 1080) && (s.format == "mp4")) || sources[0]
					let sourceHTML = `<source src="${source.url}" type="video/mp4">`
					let html = `
						<video controls muted autoplay loop class="upo-big-video">
							${sourceHTML}
						</video>
					`
					this.oPopVideoWrap.innerHTML = html
					this.oVideoMask.setAttribute("show", "1")
          let video = this.querySelector(".upo-big-video")
          setTimeout(() => {
            video.play()
          }, 100);
				})
			})
			this.oVideoClose.addEventListener("click", () => {
				this.oPopVideoWrap.innerHTML = ""
				this.oVideoMask.setAttribute("show", "")
			})
			this.oVideoMask.addEventListener("click", () => {
				this.oPopVideoWrap.innerHTML = ""
				this.oVideoMask.setAttribute("show", "")
			})
			this.oPopVideoWrap.addEventListener("click", (e) => {
				e.stopPropagation();
			});
    }
  }
  if (!customElements.get('ubt-product-overview')) {
    customElements.define('ubt-product-overview', UProductOverview);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ubt-specifications"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const expandableBox = document.getElementById('expandableBox');
    const showMore = document.getElementById('sepecifications-show-more');
    if (showMore) {
      showMore.addEventListener('click', function() {        
        expandableBox.classList.add('expanded');
        this.style.display = 'none';
      });
    }
  });

  } catch(e) { console.error(e); }
})();
})();
